import request from '@/utils/request'

// SIM卡管理分页
export function findEbikeFlowPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeFlow/findEbikeFlowPage',
    method: 'post',
    data
  })
}

// 获取sim卡剩余流量信息
export function getResidueFlow(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeFlow/getResidueFlow',
    method: 'post',
    data
  })
}

// 订单分页列表
export function orderList(data) {
  return request({
    url: '/system/api/admin/order/list',
    method: 'get',
    params: data
  })
}

// 订单新增
export function orderAdd(data) {
  return request({
    url: '/system/api/admin/order/add',
    method: 'post',
    data
  })
}

// 订单编辑
export function orderEdit(data) {
  return request({
    url: '/system/api/admin/order/edit',
    method: 'post',
    data
  })
}

// 订单修改状态
export function orderStatus(data) {
  return request({
    url: '/system/api/admin/order/status',
    method: 'post',
    data
  })
}
